// "Did you mean …?" suggestions for unknown identifiers.

/** Built-in functions the evaluator understands (kept in sync with evalExpr). */
export const BUILTIN_FUNCTIONS = [
  'sin', 'cos', 'tan', 'asin', 'acos', 'atan', 'atan2', 'abs', 'sign', 'ceil', 'floor',
  'round', 'sqrt', 'pow', 'exp', 'min', 'max', 'ln', 'log', 'len', 'concat', 'str', 'chr',
  'ord', 'norm', 'cross', 'rands', 'search', 'is_undef', 'is_num', 'is_bool', 'is_string',
  'is_list', 'is_function',
];

/** Edit distance (insert / delete / substitute / adjacent transpose). */
export function levenshtein(a: string, b: string): number {
  const m = a.length, n = b.length;
  if (m === 0) return n;
  if (n === 0) return m;
  let prev2: number[] = [];
  let prev = Array.from({ length: n + 1 }, (_, j) => j);
  for (let i = 1; i <= m; i++) {
    const cur = [i];
    for (let j = 1; j <= n; j++) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1;
      let v = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + cost);
      if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) v = Math.min(v, prev2[j - 2] + 1);
      cur.push(v);
    }
    prev2 = prev;
    prev = cur;
  }
  return prev[n];
}

/**
 * Closest candidate to `name`, or null when nothing is close enough
 * (distance ≤ 1 for short names, ≤ ⌊len/3⌋ otherwise; case-only
 * differences always match).
 */
export function didYouMean(name: string, candidates: Iterable<string>): string | null {
  const lower = name.toLowerCase();
  const limit = Math.max(1, Math.floor(name.length / 3));
  let best: string | null = null;
  let bestD = Infinity;
  for (const c of candidates) {
    if (c === name) continue;
    const d = c.toLowerCase() === lower ? 0 : levenshtein(lower, c.toLowerCase());
    if (d <= limit && d < bestD) {
      best = c;
      bestD = d;
    }
  }
  return best;
}
